"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkPromoDay = void 0;
var date_fns_1 = require("date-fns");
var getNearestActiveWeekDayFromArray_1 = require("./getNearestActiveWeekDayFromArray");
var daysOfWeek = {
    1: date_fns_1.isMonday,
    2: date_fns_1.isTuesday,
    3: date_fns_1.isWednesday,
    4: date_fns_1.isThursday,
    5: date_fns_1.isFriday,
    6: date_fns_1.isSaturday,
    7: date_fns_1.isSunday,
};
var checkToday = function (weekDay) {
    if (daysOfWeek[weekDay](new Date()))
        return true;
};
var getDaysCountBeforeWeekDay = function (dayToCompare) {
    var dayNowIdx = 0;
    var daysBeforeDayWeek = 0;
    Object.keys(daysOfWeek).forEach(function (key, idx) {
        if (daysOfWeek[key](new Date(dayToCompare)))
            daysBeforeDayWeek = idx;
        if (daysOfWeek[key](new Date()))
            dayNowIdx = idx;
    });
    return daysBeforeDayWeek >= dayNowIdx
        ? daysBeforeDayWeek - dayNowIdx
        : 7 - (dayNowIdx - daysBeforeDayWeek);
};
var checkPromoDay = function (activeDayOfWeek) {
    if (!activeDayOfWeek || (activeDayOfWeek === null || activeDayOfWeek === void 0 ? void 0 : activeDayOfWeek.length) === 0)
        return { active: true };
    var nearestDayOfWeek = (0, getNearestActiveWeekDayFromArray_1.getNearestActiveWeekDayFromArray)(activeDayOfWeek);
    if (checkToday(nearestDayOfWeek))
        return {
            active: true,
        };
    var nowDate = new Date();
    var currentHours = (0, date_fns_1.getHours)(nowDate);
    var currentMinutes = (0, date_fns_1.getMinutes)(nowDate);
    var currentSeconds = (0, date_fns_1.getSeconds)(nowDate);
    var dayToCompare = (0, date_fns_1.setISODay)(nowDate, nearestDayOfWeek - 1);
    var weekDayDate = (0, date_fns_1.addDays)(nowDate, getDaysCountBeforeWeekDay(dayToCompare));
    var differenceInSeconds = (23 - currentHours) * 3600 +
        (59 - currentMinutes) * 60 +
        (60 - currentSeconds);
    return {
        active: false,
        startAt: (0, date_fns_1.addSeconds)(weekDayDate, differenceInSeconds).toString(),
    };
};
exports.checkPromoDay = checkPromoDay;
